import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pickupLocation: null,
  dropoffLocation: null,
  pickupMode: 'sender',
};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setPickupLocation(state, action) {
      state.pickupLocation = action.payload;
    },
    setDropoffLocation(state, action) {
      state.dropoffLocation = action.payload;
    },
    swapLocations(state) {
      const temp = state.pickupLocation;
      state.pickupLocation = state.dropoffLocation;
      state.dropoffLocation = temp;
    },
    setPickupMode(state, action) {
      state.pickupMode = action.payload;
    },
  },
});

export const {
  setPickupLocation,
  setDropoffLocation,
  swapLocations,
  setPickupMode,
} = locationSlice.actions;

export default locationSlice.reducer;

